import { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Text, TextArea } from 'components/input_fields'
import { SaveButton } from 'components/buttons'
import { useDispatch, useSelector } from 'react-redux'
import { updateTechnicalTicket, technicalTicketDetails } from '../../../../redux/slices/help_desk'
import { toggleUpdateModal, toggleBool } from '../../../../redux/slices/globalSlice'
import { addUpdateHandler } from 'utils'
import { useNavigate } from 'react-router-dom'
import { Loader } from 'components/loader'

export default function UpdateTechnicalTicketForm() {
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const id = useSelector((state) => state.global.updateId)
    const details = useSelector((state) => state?.technicalTicket?.details)

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: details?.id || id || '',
            premise_id: details?.premise_id || '',
            incident_title: details?.incident_title || '',
            admin_remark: details?.admin_remark || '',
        },
        validationSchema: Yup.object({
            incident_title: Yup.string().trim().required('Title is required'),
            admin_remark: Yup.string().trim().required('Note is required'),
        }),
        onSubmit: (values, action) => {
            setSpinner(true)
            dispatch(updateTechnicalTicket({
                technical_ticket_id: values.id,
                premise_id: values.premise_id,
                incident_title: values.incident_title.trim(),
                admin_remark: values.admin_remark.trim(),
            })).then((res) => addUpdateHandler({
                res: res.payload,
                action,
                navigate,
                success_toast: 'Technical ticket updated successfully',
                wrong_toast: 'Something went wrong',
                navigate_route: '',
                spinner: setSpinner,
                toggle: () => {
                    dispatch(toggleUpdateModal())
                    dispatch(toggleBool())
                },
            }))
        },
    })

    const { values, errors, touched, handleChange, handleBlur, handleSubmit } = formik

    useEffect(() => {
        if (!id) return
        setLoading(true)
        dispatch(technicalTicketDetails({ id, navigate })).finally(() => setLoading(false))
    }, [dispatch, id, navigate])

    if (loading) {
        return <div className="py-4"><Loader /></div>
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Text
                label_name="Title"
                mandatory
                placeholder="Enter title"
                disabled={false}
                name="incident_title"
                value={values.incident_title}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.incident_title && touched.incident_title
                    ? <span className="field_error">{errors.incident_title}</span>
                    : null}
            />
            <TextArea
                label_name="Note"
                mandatory
                placeholder="Enter note"
                disabled={false}
                name="admin_remark"
                value={values.admin_remark}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.admin_remark && touched.admin_remark
                    ? <span className="field_error">{errors.admin_remark}</span>
                    : null}
            />
            <div className="d-flex justify-content-end mt-3">
                <div className="col-lg-6">
                    <SaveButton button_name="Update technical ticket" spinner={spinner} />
                </div>
            </div>
        </Form>
    )
}
